import React, { useEffect } from 'react';
import { Route, useHistory } from 'react-router-dom';
import { AnimatedSwitch } from 'react-router-transition';
import { useSelector } from 'react-redux';
import SelectArea from './containers/SelectArea';
import BeeSelectionMethod from './containers/BeeSelectionMethod';
import SelectBees from './containers/SelectBees';
import ForcedLoading from './containers/Loading';
import PlantSelectionMethod from './containers/PlantSelectionMethod';
import SelectPlants from './containers/SelectPlants';
import ShowFloweringArch from './containers/ShowFloweringArch/index';
import Overview from './containers/Overview';
import PlantAdvice from './containers/PlantAdvice';
import Frontpage from './containers/Frontpage';
import ProtectedRoute from './components/ProtectedRoute';
import {
  selectIds,
  selectSelectedBeeIds,
} from './ducks/bees';
import GenericError from './containers/GenericError';
import { selectApproved } from './ducks/area';
import { selectSessionId } from './ducks/session';
import {useAndInitializePostHog} from "./components/PosthogTracker/usePageTracker";

const App = () => {
  useAndInitializePostHog()
  const approved = useSelector(selectApproved);
  const beeIds = useSelector(selectIds);
  const selectedBeeIds = useSelector(selectSelectedBeeIds);
  const id = useSelector(selectSessionId);
  const history = useHistory();

  useEffect(() => history.listen((location) => {
    if (history.action === 'POP') {
      if (location.pathname === '/loading') {
        history.goBack();
      }
    }
  }), []);

  const accessFunc = (level) => {
    if (level >= 1) {
      if (!approved || !beeIds.length > 0) {
        return {
          hasAccess: false,
          redirectPath: '/select-area',
        };
      }
    }
    if (level >= 2) {
      if (!selectedBeeIds.length > 0) {
        return {
          hasAccess: false,
          redirectPath: '/bee-selection',
        };
      }
    }

    return {
      hasAccess: true,
      redirectPath: null,
    };
  };

  return (
    <div key={id}>
      <GenericError />
      <AnimatedSwitch
        atEnter={{ opacity: 0 }}
        atLeave={{ opacity: 0 }}
        atActive={{ opacity: 1 }}
      >
        <Route exact path="/">
          <Frontpage />
        </Route>
        <Route exact path="/select-area">
          <SelectArea />
        </Route>
        <ProtectedRoute
          path="/bee-selection-method"
          component={BeeSelectionMethod}
          accessFunc={() => accessFunc(1)}
          exact
        />
        <ProtectedRoute
          path="/bee-selection"
          component={SelectBees}
          accessFunc={() => accessFunc(1)}
          exact
        />
        <ProtectedRoute
          path="/plant-selection-method"
          component={PlantSelectionMethod}
          accessFunc={() => accessFunc(2)}
          exact
        />
        <ProtectedRoute
          path="/plant-selection"
          component={SelectPlants}
          accessFunc={() => accessFunc(2)}
          exact
        />
        <ProtectedRoute
          path="/flowering-arch"
          component={ShowFloweringArch}
          accessFunc={() => accessFunc(2)}
          exact
        />
        <ProtectedRoute
          path="/plant-advice"
          component={PlantAdvice}
          accessFunc={() => accessFunc(2)}
          exact
        />
        <ProtectedRoute
          path="/overview"
          component={Overview}
          accessFunc={() => accessFunc(2)} // todo: create extra level with advice selected
          exact
        />
        <Route exact path="/loading">
          <ForcedLoading />
        </Route>
      </AnimatedSwitch>
    </div>
  );
};

export default App;
